import { render, staticRenderFns } from "./ContentImage.vue?vue&type=template&id=cd97a1fa&scoped=true"
import script from "./ContentImage.vue?vue&type=script&lang=js"
export * from "./ContentImage.vue?vue&type=script&lang=js"
import style0 from "./ContentImage.vue?vue&type=style&index=0&id=cd97a1fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd97a1fa",
  null
  
)

export default component.exports